module.exports = __webpack_public_path__ + "img/back-icon.460d4ee4.svg";